// import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './NavBar/NavBar';
import AppTheme from './theme';
import Explore from './ExploreTheApp/Explore';
// import OurMission from './OurMission/delete';
import AboutUs from './OurMission/OurMission';
import Testimonials from './Testimonials/Testimonials'; 
import CardGrid from './HowTos/CardGrid'
import HowToPage from './HowTos/HowToPage';
import LandingPageNew from './LandingPage/LandingPageNew';
// import Login from './Login/login';
import Privacy from './Privacy/privacy';

// import Button from 'react-bootstrap/Button';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  const appStyle = {
    backgroundColor: AppTheme.backgroundLight, // Replace with your desired background color
    minHeight: '100vh', // Ensure app takes at least the height of the viewport
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <Router>
      <div className="App" style={appStyle}>
            <NavBar />
        <div className = "main-content">
        <Routes>
          <Route path="/" element={<LandingPageNew />} />
          <Route path="/explore" element={<Explore />} />
          {/* <Route path="/ourmission" element={<OurMission />} /> */}
          <Route path="/ourmission" element={<AboutUs />} />
          <Route path="/howto" element={<CardGrid />} />
          <Route path="/howto/:slug" element={<HowToPage />} />
          <Route path="/testimonials" element={<Testimonials />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
